export default __webpack_public_path__ + "static/media/gw.e46819f1.svg";